import {Navigate, Route, Routes} from "react-router-dom";
import React from "react";
import {useAuth} from "../context/user";
import {ProtectedRoute} from "../auth";
import {Contacts} from "../pages/siren/Contacts";
import {Groups} from "../pages/siren/Groups";
import {Import} from "../pages/siren/Import";
import {SirenProvider} from "../pages/siren/SirenContext";
import {ContactEdit} from "../pages/siren/subpages/ContactEdit";
import { ContactGroupsEdit } from "../pages/siren/subpages/ContactGroupEdit";
import { Templates } from "../pages/siren/Templates";
import {TemplateEdit} from "../pages/siren/subpages/TemplateEdit";
import {Audio} from "../pages/siren/Audio";
import {AudioEdit} from "../pages/siren/subpages/AudioEdit";
import {Alerts} from "../pages/siren/Alerts";
import {AlertStatus} from "../pages/siren/subpages/AlertStatus";
import {Hotlines} from "../pages/siren/Hotlines";
import {HotlineNumberEdit} from "../pages/siren/subpages/HotlineNumberEdit";
import {HotlineEdit} from "../pages/siren/subpages/HotlineEdit";
import {SirenMessageContents} from "../pages/siren/SirenMessageContents";
import {SirenMessageContentEdit} from "../pages/siren/subpages/SirenMessageContentEdit";
import SirenPortalBrandingPage from "../features/management-v2/SirenPortalBrandingPage";
import SirenEmailBrandingPage from "../features/management-v2/SirenEmailBrandingPage";
import {SirenDriversPage} from "../features/management-v2/SirenDriversPage";
import {SirenClientDriverConfigPage, SirenClientDriverConfigEditPage} from "../features/management-v2/SirenClientDriverConfigPage";
import SirenDefaultBroadcastConfigPage, {SirenDefaultBroadcastConfigEditPage} from "../features/management-v2/SirenDefaultBroadcastConfigPage";
import SirenDefaultDeliveryMethodsPage, {SirenDefaultDeliveryMethodsEditPage} from "../features/management-v2/SirenDefaultDeliveryMethodsPage";
import SirenPhoneCallConfigPage from "../features/management-v2/SirenPhoneCallConfigPage";
import SirenSMSConfigPage from "../features/management-v2/SirenSMSConfigPage";
import SirenCountriesPage from "../features/management-v2/SirenCountriesPage";
import SirenBillingStatsPage from "../features/management-v2/SirenBillingStatsPage";

export const SirenRoutes = () => {
    const {isSuperAdmin, isDepartmentAdmin} = useAuth();
    return (
        <SirenProvider>
            <Routes>
                <Route
                    path="contacts"
                    element={
                        <ProtectedRoute accessLevel="department">
                            <Contacts/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="contacts/:id/edit"
                    element={
                        <ProtectedRoute>
                            <ContactEdit/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="groups"
                    element={
                        <ProtectedRoute accessLevel="department">
                            <Groups/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="groups/:id/edit"
                    element={
                        <ProtectedRoute>
                            <ContactGroupsEdit/>
                        </ProtectedRoute>
                    }
                />



                <Route
                    path="import"
                    element={
                        <ProtectedRoute>
                            <Import/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="templates"
                    element={
                        <ProtectedRoute>
                            <Templates/>
                        </ProtectedRoute>
                    }
                    />

                <Route
                    path="audio"
                    element={
                        <ProtectedRoute>
                            <Audio/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="audio/:id/edit"
                    element={
                        <ProtectedRoute>
                            <AudioEdit/>
                        </ProtectedRoute>
                    }
                />


                <Route
                    path="templates/:id/edit"
                    element={
                        <ProtectedRoute>
                            <TemplateEdit/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="alerts"
                    element={
                        <ProtectedRoute>
                            <Alerts/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="alerts/:id"
                    element={
                        <ProtectedRoute>
                            <AlertStatus/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="hotlines"
                    element={
                        <ProtectedRoute>
                            <Hotlines/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="hotline-numbers/:id/edit"
                    element={
                        <ProtectedRoute>
                            <HotlineNumberEdit/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="hotlines/:id/edit"
                    element={
                        <ProtectedRoute>
                            <HotlineEdit/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="message-contents"
                    element={
                        <ProtectedRoute>
                            <SirenMessageContents/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="message-contents/:id/edit"
                    element={
                        <ProtectedRoute>
                            <SirenMessageContentEdit/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="recipient-portal"
                    element={
                        isDepartmentAdmin ? <Navigate to="/siren/sms-config" replace/> : (
                            <ProtectedRoute accessLevel={"all"}>
                                <SirenPortalBrandingPage/>
                            </ProtectedRoute>
                        )
                    }
                />
                <Route
                    path="email-branding"
                    element={
                        <ProtectedRoute accessLevel={"all"}>
                            <SirenEmailBrandingPage/>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="drivers"
                    element={
                        <ProtectedRoute accessLevel={"all"}>
                            {isSuperAdmin ? <SirenDriversPage/> : <Navigate to="/siren/recipient-portal" replace/>}
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="drivers/client-config"
                    element={
                        <ProtectedRoute accessLevel={"all"}>
                            {isSuperAdmin ? <SirenClientDriverConfigPage/> : <Navigate to="/siren/recipient-portal" replace/>}
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="drivers/client-config/:clientID"
                    element={
                        <ProtectedRoute accessLevel={"all"}>
                            {isSuperAdmin ? <SirenClientDriverConfigEditPage/> : <Navigate to="/siren/recipient-portal" replace/>}
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="billing-stats"
                    element={
                        <ProtectedRoute accessLevel={"all"}>
                            {isSuperAdmin ? <SirenBillingStatsPage/> : <Navigate to="/siren/recipient-portal" replace/>}
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="default-broadcast-config"
                    element={
                        <ProtectedRoute accessLevel={"all"}>
                            <SirenDefaultBroadcastConfigPage/>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="default-broadcast-config/create"
                    element={
                        <ProtectedRoute accessLevel={"all"}>
                            <SirenDefaultBroadcastConfigEditPage/>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="default-broadcast-config/edit/:id"
                    element={
                        <ProtectedRoute accessLevel={"all"}>
                            <SirenDefaultBroadcastConfigEditPage/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="default-delivery-methods"
                    element={
                        <ProtectedRoute accessLevel={"all"}>
                            <SirenDefaultDeliveryMethodsPage/>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="default-delivery-methods/create"
                    element={
                        <ProtectedRoute accessLevel={"all"}>
                            <SirenDefaultDeliveryMethodsEditPage/>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="phone-call-config"
                    element={
                        <ProtectedRoute accessLevel={"all"}>
                            <SirenPhoneCallConfigPage/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="default-delivery-methods/edit/:id"
                    element={
                        <ProtectedRoute accessLevel={"all"}>
                            <SirenDefaultDeliveryMethodsEditPage/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="sms-config"
                    element={
                        <ProtectedRoute accessLevel={"all"}>
                            <SirenSMSConfigPage/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="countries"
                    element={
                        <ProtectedRoute accessLevel={"all"}>
                            <SirenCountriesPage/>
                        </ProtectedRoute>
                    }
                />
            </Routes>
        </SirenProvider>
    )
}